var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconGoTo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.638 8.52898L12.0522 9.9432L17.002 4.99345L12.0522 0.0437012L10.638 1.45791L13.1365 3.95638H4.99849C2.78935 3.95638 0.998493 5.74724 0.998493 7.95638V9.95638H2.99849V7.95638C2.99849 6.85181 3.89392 5.95638 4.99849 5.95638H13.2106L10.638 8.52898Z",
    fill: "#606273"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconGoTo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-go-to.a551ac83.svg";
export { ForwardRef as ReactComponent };